export default "/images/07 Step2Plan-Provider-To select goals-02.png?e615b2deb6ebe6734a666cfab015469c";